import { render } from "./FeedItemComponent.vue?vue&type=template&id=3fb2f06c&scoped=true&ts=true"
import script from "./FeedItemComponent.vue?vue&type=script&lang=ts"
export * from "./FeedItemComponent.vue?vue&type=script&lang=ts"

import "./FeedItemComponent.vue?vue&type=style&index=0&id=3fb2f06c&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb2f06c"]])

export default __exports__